import { render, staticRenderFns } from "./BookItem.vue?vue&type=template&id=192e84f4&scoped=true"
import script from "./BookItem.vue?vue&type=script&lang=js"
export * from "./BookItem.vue?vue&type=script&lang=js"
import style0 from "./BookItem.vue?vue&type=style&index=0&id=192e84f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192e84f4",
  null
  
)

export default component.exports